import CourseModel from './course.model';

export default class CourseList {
  constructor() {
    this._selectedCourses = [];
    this._courses = [];
  }

  addSelectedCourse(selectedCourse) {
    this._selectedCourses.push(selectedCourse);
  }

  get selectedCourses() {
    return this._selectedCourses;
  }

  clearSelectedCourses() {
    this._selectedCourses = [];
  }

  set courses(courseList) {
    this._courses = [];
    if (courseList instanceof Array)
      courseList.forEach((courseInfo) => {
        this._courses.push(new CourseModel(courseInfo));
      });
  }

  get courses() {
    return this._courses;
  }

  get courseListPageData() {
    return {
      courses: this.courses
    };
  }
}
